<template>
  <div
    class="BBP-popups-file"
    :style="position"
  >
    <span @click="onClick" >{{description}}</span>
    <BBPFileCell :row="row" :column="column" :from-params="true"/>
  </div>
</template>

<script>

import BBPFileCell from '@/components/Main/BBPTable/BBPFileCell/BBPFileCell'

export default {
  name: 'BBPPopupsFile',
  props: {
    position: {
      type: Object,
      default: () => ({})
    },
    description: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    popupIcon: Function
  },
  components: {
    BBPFileCell
  },
  methods: {
    onClick () {
      this.$emit('onClickPopup')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .BBP-popups-file {
    display: flex;
    align-items: center;
    background: $color-white;
    border-radius: 4px;
    padding: 10px 10px 10px 10px;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    cursor: pointer;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPPopups/BBPPopupsFile.vue